<div class="welcome-dialog">
  <div class="welcome-header">
    <mat-icon class="welcome-logo" svgIcon="cfa-logo" aria-hidden="true"></mat-icon>
    <h1 class="welcome-title">Welcome to the new &amp; improved Restaurant Network Dashboard</h1>
  </div>

  <mat-dialog-content class="welcome-content">
    <p>
      We've refreshed the dashboard with a new look and improvements throughout.
      Take a look around &mdash; everything you rely on is still here, just better.
    </p>
    <p class="welcome-contact">
      Questions or running into an issue? Reach out to
      <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="welcome-actions">
    <button id="welcome-dismiss" mat-raised-button color="primary" (click)="close()" cdkFocusInitial>
      Got it
    </button>
  </mat-dialog-actions>
</div>
